const kindLabels = { family: "Family", subfamily: "Subfamily", category: "Category", subcategory: "Subcategory", item: "Item" };
const ruleLabels = {
  only: "Included in the allowed selection",
  all_except: "Excluded from access",
  all: "All articles",
  allow: "Allow",
  deny: "Deny",
};
const resolutionLabels = {
  inherited: "Inherited from the absorbed classification",
  principal_wins: "The principal's rule takes precedence",
  combined: "Equivalent rules combined",
  restored: "Original rule restored",
};
const resolutionDescriptions = {
  inherited: "The same inclusion or exclusion will apply to the principal classification.",
  principal_wins: "The principal already has an explicit rule. That rule is kept and applies to the merged classification, even if the absorbed rule differs.",
  combined: "Matching rules are kept on the principal without duplication.",
  restored: "The rule saved before the merge will be restored to its original classification.",
};

function Scope({ scope, t }) {
  const label = scope?.name || scope?.code || t("Name unavailable");
  return <span className="tm-accessScope"><strong>{scope?.kind ? `${t(kindLabels[scope.kind] || scope.kind)}: ` : ""}{label}</strong>{scope?.code && scope.code !== label && <small>{scope.code}</small>}</span>;
}

export default function TaxonomyMergeAccessChanges({ changes, restoring = false, blocked = false, t }) {
  // An absent field means an older preview response, not a verified empty plan.
  if (!Array.isArray(changes)) return null;
  if (!changes.length && blocked) return null;
  const users = new Set(changes.map((change) => change.user?.id ?? change.user?.name));
  const rule = (value) => t(value ? ruleLabels[value] || value : "No explicit rule");
  return <section className="tm-accessChanges" aria-label={t(restoring ? "Item access to restore" : "Item access after merging")}>
    <h4>{t(restoring ? "Item access to restore" : "Item access after merging")}</h4>
    {!changes.length ? <p className="tm-muted">{t("No item access rules need to change.")}</p> : <>
      <p>{t(restoring ? "Original access rules are restored from the saved merge. Review each user's before and after rules below." : "Rules on absorbed classifications are inherited by the principal, including exclusions. Where explicit rules conflict, the principal's rule takes precedence.")}</p>
      <dl className="tm-stats"><div><dt>{t("Affected users")}</dt><dd>{users.size}</dd></div><div><dt>{t("Rule changes")}</dt><dd>{changes.length}</dd></div></dl>
      <ol className="tm-accessList">{changes.map((change, index) => {
        const resolution = restoring ? "restored" : change.resolution;
        return <li className="tm-accessChange" key={`${change.user?.id}:${change.from?.kind}:${change.from?.id}:${index}`}>
          <div className="tm-accessHeading"><h5>{change.user?.name || t("Name unavailable")}</h5><span className="tm-accessResolution">{t(resolutionLabels[resolution] || resolution || "Rule changes")}</span></div>
          <div className="tm-grid">
            <div><h6>{t("Before")}</h6><Scope scope={change.from} t={t} /><p className="tm-accessRule">{rule(change.before_rule_type)}</p></div>
            <div><h6>{t("After")}</h6><Scope scope={change.to} t={t} /><p className="tm-accessRule">{rule(change.after_rule_type)}</p></div>
          </div>
          {resolutionDescriptions[resolution] && <p className="tm-muted">{t(resolutionDescriptions[resolution])}</p>}
        </li>;
      })}</ol>
      {!restoring && <p className="tm-muted">{t("The original rules are saved so they can be restored when this merge is separated.")}</p>}
    </>}
  </section>;
}
